export enum AppRoutes {
    LOGIN = '/login',
    LOGIN_WITH_REFERRAL = '/login/:referral_code',
    SIGNUP = '/signup',
    SIGNUP_WITH_REFERRAL = '/signup/:referral_code',
    RESET_PASSWORD = '/reset-password',
    SET_NEW_PASSWORD = '/set-new-password/:userId/:authToken',
    PIN_MAP = '/',
    SETTINGS = '/settings',
    WELCOME = '/welcome',
    PINNERS = '/pinners',
    CONSULTANCY = '/consultancy/:userId',
    PROFILE = '/profile/:userId',
    PINNER_PRO_PROFILE = '/pinner-pro-profile/:userId',
    ON_BOARDING = '/onboarding/:userId/:authToken',
    FEEDBACK = '/feedback',
    NOTIFICATIONS = '/notifications',
    TERMS = '/terms',
    PRIVACY = '/privacy',
    CHAT = '/chat',
    REFERRAL = '/referral',
    BILLING = '/billing',
    BILLING_SUCCESS = '/billing/success',
    BILLING_CANCELED = '/billing/canceled',
}